import React from 'react';
import QRCode from 'qrcode.react' ;

export default ({url, ...rest}) => {
    return <QRCode value={url} {...rest} />
}